import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewToggle = ({ viewMode, onViewModeChange, className = '' }) => {
  const viewOptions = [
    {
      value: 'grid',
      label: 'Grid View',
      icon: 'Grid3X3',
      description: 'Show products in a grid layout'
    },
    {
      value: 'list',
      label: 'List View',
      icon: 'List',
      description: 'Show products in a list layout'
    }
  ];

  return (
    <div className={`flex items-center bg-surface border border-border rounded-lg p-1 ${className}`}>
      {/*viewOptions?.map((option) => (
        <button
          key={option.value}
          onClick={() => onViewModeChange(option.value)}
          className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-smooth ${
            viewMode === option.value
              ? 'bg-primary text-white shadow-sm'
              : 'text-text-secondary hover:text-text-primary hover:bg-muted'
          }`}
          title={option.description}
          aria-label={option.label}
        >
          <Icon name={option.icon} size={16} />
          <span className="text-sm font-medium hidden sm:inline">{option.label}</span>
        </button>
      ))*/}
    </div>
  );
};

export default ViewToggle;